import React from 'react';
import Navbar from '../components/Navbar/Navbar';
import Hero from '../components/Hero/Hero';
import Services from '../components/Services/Services';
import Portfolio from '../components/Portfolio/Portfolio';
import TechStack from '../components/TechStack/TechStack';
import Pricing from '../components/Pricing/Pricing';
import Contact from '../components/Contact/Contact';
import Footer from '../components/Footer/Footer';
import classes from './Home.module.scss';
import Testimonials from '../components/Testimonials';

const Home = () => {
  return (
    <div className={classes.home}>
      <Navbar />
      <main>
        <Hero />
        <Pricing />
        <Services />
        <Portfolio />
        <Testimonials />
        <TechStack />
        <Contact />
      </main>
      <Footer />
    </div>
  );
};

export default Home;
